import { CLOUD_PICKERS } from './cloudPickers/registry';
import {
  CloudPickerFile,
  CloudPickerProvider,
  LaunchCloudPickerOptions
} from './cloudPickers/types';

export const preloadCloudPickerProvider = async (
  provider: CloudPickerProvider
) => {
  return await CLOUD_PICKERS[provider].preload?.();
};

export const getCloudPickerErrorTranslationKey = (
  provider: CloudPickerProvider,
  error: unknown
) =>
  CLOUD_PICKERS[provider].getErrorTranslationKey?.(error) ||
  'lomavisCreator.additionalOptions.cloudImportFailed';

export const launchCloudPickerProvider = async (
  provider: CloudPickerProvider,
  options: LaunchCloudPickerOptions
) => {
  return await CLOUD_PICKERS[provider].launch(options);
};

export type { CloudPickerFile, CloudPickerProvider, LaunchCloudPickerOptions };
